/* eslint-disable */
import React, {useState, useEffect} from "react";
import styles from "./EditSurveyDetail.module.css";
import {FormControlLabel, IconButton, InputAdornment, Modal, Radio, RadioGroup, TextField, withStyles} from "@material-ui/core";
import PuiButton from "../elements/PuiButton";
import PuiTypography from "../elements/PuiTypography";
import AddCircleOutlineOutlinedIcon from "@material-ui/icons/AddCircleOutlineOutlined";
import HighlightOffIcon from "@material-ui/icons/HighlightOff";
import AddIcon from "@material-ui/icons/Add";
import {Survey} from "../../models/survey";
import PuiMessage from "../widgets/PuiMessage";
import {CountWord} from "../../utils/ObjectUtils";
import EditIcon from "@material-ui/icons/Edit";

const RedRadio = withStyles({
    root: {
        "&$checked": {
            color: "var(--red)"
       }
   },
    checked: {}
})((props) => <Radio color="default" {...props}/>);

interface EditSurveyDetailProps {
    setIsSaved: (isSaved: boolean) => void;
    surveyIndex: number;
    surveyDetail: Survey;
    UpdateSurveyDetail: (surveyIndex: number, surveyDetail: Survey) => void;
}

function EditSurveyDetail({setIsSaved, surveyIndex, surveyDetail, UpdateSurveyDetail}: EditSurveyDetailProps) {

    // モーダル画面表示制御
    const [isOpenEditSurveyModal, ShowEditSurveyModal] = useState(false);
    const handlePropagation = (event: React.MouseEvent) => {
        event.nativeEvent.stopImmediatePropagation();
   };

    const OpenEditSurveyModal = () =>{
        console.log("OpenEditSurveyModal start");
        ShowEditSurveyModal(true);

   };

    const CloseEditSurveyModal = () =>{
        console.log("CloseEditSurveyModal start");
        ShowEditSurveyModal(false);
        CheckInputSurveyName(false);
        ChangeDisplayMillisCustomFlagList([false, false, false, false, false]);
        ErrorInputLimit([false, false, false, false, false]);
   };

    const [survey, ChangeSurvey] = useState<Survey>();
    useEffect(() => {
        if(surveyDetail){
            ChangeSurvey(surveyDetail);
       }
    // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [isOpenEditSurveyModal]);

    useEffect(() => {
        if(isOpenEditSurveyModal && survey){
            const temp = [false, false, false, false, false];
            survey.questionList.map((function(row, index) {
                if(![15000, 30000, 60000, 0].includes(row.displayMillis)){
                    temp[index] = true;
               }
                return null;
           }));
            ChangeDisplayMillisCustomFlagList(temp);
            console.log(temp);
       }
    // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [isOpenEditSurveyModal, survey]);

    // アンケート名入力
    const [isErrorInputSurveyName,CheckInputSurveyName] = useState(false);
    const InputSurveyName= (event: any) => {
        console.log("InputSurveyName start");
        if (CountWord(event.target.value) > 30) {
            CheckInputSurveyName(true);
       }
        else{
            CheckInputSurveyName(false);
            if(survey){
                survey.title = event.target.value;
           }
       }
   };

    // 表示回数選択
    const SelectDisplayFlag= (event: any) => {
        console.log("SelectDisplayFlag start");
        if(survey){
            if(event.target.value === "1"){
                survey.multipleAnswer = true;
           }else if(event.target.value === "0"){
                survey.multipleAnswer = false;
           }else{
                console.log("SelectDisplayFlag else");
           }
       }
   };

    // 設問入力
    const InputQuestion= (index: number, event: any) => {
        console.log("InputQuestion start");
        if(survey){
            const temp: Survey = {...survey};
            temp.questionList[index].content = event.target.value;
            ChangeSurvey(temp);
       }
   };

    // 回答方式入力
    const SelectAnswerFormat= (index: number, event: any) => {
        console.log("SelectAnswerFormat start");
        if(survey){
            if(event.target.value === "0"){
                survey.questionList[index].answerType = 0;
           }else if(event.target.value === "1"){
                survey.questionList[index].answerType = 1;
           }else{
                console.log("SelectAnswerFormat failed");
           }
       }
   };

    // スキップフラグ選択
    const SelectSkipFlag = (index: number, event: any) => {
        console.log("SelectSkipFlag start");
        if(survey){
            if(event.target.value === "true"){
                survey.questionList[index].skipFlag = true;
           }else{
                survey.questionList[index].skipFlag = false;
           }
       }
   };

    // 選択肢入力
    const InputChoice= (index: number, contentIndex: number, event: any) => {
        console.log("InputChoice start");
        if(survey){
            const temp: Survey = {...survey};
            temp.questionList[index].choiceList[contentIndex].content = event.target.value;
            ChangeSurvey(temp);
       }
   };

    // 選択肢追加
    const AddChoice= (index: number) => {
        console.log("InputAnswer start");
        if(survey){
            const temp = {...survey};
            temp.questionList[index].choiceList.push({choiceId: -1, content: ""});
            ChangeSurvey(temp);
       }
   };

    //制限時間入力
    const [displayMillisCustomFlagList, ChangeDisplayMillisCustomFlagList] = useState([false, false, false, false, false]);
    const SelectAnswerLimit= (index: number, num: number) => {
        console.log("SelectAnswerLimit start");
        if(num !== 1){
            console.log("false");
            const temp = [...displayMillisCustomFlagList];
            temp[index] = false;
            ChangeDisplayMillisCustomFlagList(temp);
            if(survey){
                survey.questionList[index].displayMillis = num;
           }
       }else{
            console.log("true");
            const temp = [...displayMillisCustomFlagList];
            temp[index] = true;
            ChangeDisplayMillisCustomFlagList(temp);
            if(survey){
                survey.questionList[index].displayMillis = 0;
           }
       }
        const temp = [...isErrorInputLimit];
        temp[index] = false;
        ErrorInputLimit(temp);
   };

    const [isErrorInputLimit, ErrorInputLimit] = useState([false, false, false, false, false]);
    const InputDisplayLimit = (index: number, num: number) => {
        console.log("InputDisplayLimit start");
        if(num > 0 && num <= 600000){
            const temp = [...isErrorInputLimit];
            temp[index] = false;
            ErrorInputLimit(temp);
            if(survey){
                survey.questionList[index].displayMillis = num;
           }
       }else{
            const temp = [...isErrorInputLimit];
            temp[index] = true;
            ErrorInputLimit(temp);
       }
   };

    // 設問追加
    const AddQuestion = () => {
        console.log("AddQuestion start");
        if(survey){
            const temp = {...survey};
            temp.questionList.push({
                questionId: -1,
                content: "",
                answerType: 0,
                skipFlag: false,
                displayMillis: 15000,
                choiceList: [{choiceId: -1, content: ""},{choiceId: -1, content: ""}],
                answerHistory: [],
                videoIdList: []
           });
            ChangeSurvey(temp);
       }
   };

    // 設問削除
    const DeleteQuestion = (index: number) => {
        console.log("DeleteQuestion start");
        if(survey){
            const temp = {...survey};
            temp.questionList.splice(index, 1);
            ChangeSurvey(temp);
       }
   };

    // const [errorFlag, ChangeErrorFlag] = useState(false);
    const [isVisibleErrorMessage, ChangeErrorMessageVisiblity] = useState(false);
    const [errorMessage, ChangeErrorMessage] = useState("");
    const CloseErrorMessage = () => {
        ChangeErrorMessageVisiblity(false);
        ChangeErrorMessage("");
   };

    const ClickCancelButton = () => {
        console.log("ClickCancelButton start");
        CloseEditSurveyModal();
   };

    const ClickDoneButton = () => {
        console.log("ClickDoneButton start");
        if(survey){
            let error = false;
            if(survey.title === ""){
                ChangeErrorMessageVisiblity(true);
                ChangeErrorMessage("アンケート名を入力してください");
                error = true;
           }else if(isErrorInputSurveyName === true){
                ChangeErrorMessage("アンケート名は30字以内で入力してください");
                ChangeErrorMessageVisiblity(true);
                error = true;
           }else if(isErrorInputLimit.includes(true)){
                ChangeErrorMessage("アンケート表示時間を正しく入力してください");
                ChangeErrorMessageVisiblity(true);
                error = true;
           }else{
                const choiceNum: number[] = [];
                const nullCheck: string[] = [];
                const questionStringLengthCheck: number[] = [];
                const choiceStringLengthCheck: number[] = [];
                survey.questionList.map((function(row, index) {
                    choiceNum.push(0);
                    nullCheck.push(row.content);
                    questionStringLengthCheck.push(CountWord(row.content));
                    row.choiceList.map((function(choice) {
                        if(choice.content !== ""){
                            choiceNum[index] = choiceNum[index] + 1;
                            choiceStringLengthCheck.push(CountWord(choice.content));
                       }
                        return null;
                   }));
                    return null;
               }));
                if(nullCheck.includes("") === true){
                    ChangeErrorMessage("設問を入力してください");
                    ChangeErrorMessageVisiblity(true);
                    error = true;
               }else if(choiceNum.includes(0) === true || choiceNum.includes(1) === true){
                    ChangeErrorMessage("選択肢は２つ以上用意してください");
                    ChangeErrorMessageVisiblity(true);
                    error = true;
               }else if(questionStringLengthCheck.findIndex((question) => question > 50) !== -1){
                    ChangeErrorMessage("設問は50字以内で入力してください");
                    ChangeErrorMessageVisiblity(true);
                    error = true;
               }else if(choiceStringLengthCheck.findIndex((question) => question > 30) !== -1){
                    ChangeErrorMessage("選択肢は30字以内で入力してください");
                    ChangeErrorMessageVisiblity(true);
                    error = true;
               }
           }

            if(error === false){
                CloseEditSurveyModal();
                // 選択肢に””が含まれている場合、選択肢を削除する
                survey.questionList.map((function(row) {
                    row.choiceList.map((function(choice, choiceIndex) {
                        if(choice.content.length === 0){
                            row.choiceList.splice(choiceIndex, 1);
                       }
                        return null;
                   }));
                    return null;
               }));
                UpdateSurveyDetail(surveyIndex, survey);
           }
       }
   };

    return (
        <>
            <div className={styles.editIcon} onClick={handlePropagation}>
                <EditIcon style={{cursor:"pointer", color: "var(--red)"}} onClick={OpenEditSurveyModal}/>
            </div>
            {survey &&
                <Modal
                    open={isOpenEditSurveyModal}
                    onClose={CloseEditSurveyModal}
                >
                    <div className={styles.root}>
                        <div className={styles.title}>
                            <ul className={styles.surveyForm}>
                                <li>
                                    <PuiTypography size={20} bold>アンケートを編集</PuiTypography>
                                    <TextField color="secondary" id="description" defaultValue={survey.title} onChange={InputSurveyName} multiline autoComplete="off" className={styles.inputForm}
                                        variant="outlined" placeholder="アンケート名を入力"  helperText={isErrorInputSurveyName && <span style={{color: "var(--red)"}}>全角30文字以内で正しく入力してください</span>}
                                    />
                                </li>
                                <li>
                                    <RadioGroup aria-label="displayFlag" name="displayFlag" defaultValue={survey.multipleAnswer ? "1" : "0"}  onChange={SelectDisplayFlag} style={{display:"block"}}>
                                        <FormControlLabel value="0" control={<RedRadio/>} label="一回のみ表示"/>
                                        <FormControlLabel value="1" control={<RedRadio/>} label="再表示する"/>
                                    </RadioGroup>
                                </li>
                            </ul>
                        </div>
                        <div className={styles.surveyList}>
                            {survey.questionList.map((row, index)=>(
                                <ul key={index} className={styles.form}>
                                    {(index > 0) &&
                                        <IconButton onClick={() => DeleteQuestion(index)} className={styles.deleteIcon}>
                                            <HighlightOffIcon style={{color:"var(--gray-85)"}}/>
                                        </IconButton>
                                   }
                                    <li>
                                        <PuiTypography bold>設問{index +1}</PuiTypography>
                                    </li>
                                    <li>
                                        <TextField color="secondary" id="description" defaultValue={survey.questionList[index].content} onChange={(event) => InputQuestion(index, event)} multiline autoComplete="off" className={styles.inputForm}
                                            variant="outlined" placeholder="設問を入力"  helperText={CountWord(survey.questionList[index].content) > 50 && <span style={{color: "var(--red)"}}>全角50文字以内で正しく入力してください</span>}
                                        />
                                    </li>
                                    <li>
                                        <RadioGroup aria-label="answerFormat" name="answerFormat" defaultValue={String(survey.questionList[index].skipFlag)} onChange={(event) => SelectSkipFlag(index, event)} style={{display:"block"}}>
                                            <FormControlLabel value="true" control={<RedRadio/>} label="スキップ可"/>
                                            <FormControlLabel value="false" control={<RedRadio/>} label="スキップ不可"/>
                                        </RadioGroup>
                                    </li>
                                    <li>
                                        <RadioGroup aria-label="answerFormat" name="answerFormat" defaultValue={String(row.answerType)}  onChange={(event) => SelectAnswerFormat(index, event)} style={{display:"block"}}>
                                            <FormControlLabel value="0" control={<RedRadio/>} label="単一回答"/>
                                            <FormControlLabel value="1" control={<RedRadio/>} label="複数回答"/>
                                        </RadioGroup>
                                    </li>
                                    <li>
                                        {
                                            row.choiceList.map((content, num) =>(
                                                <TextField key={num} color="secondary" id="description" defaultValue={content.content} onChange={(event) => InputChoice(index, num, event)} multiline autoComplete="off" className={styles.inputForm}
                                                    variant="outlined" placeholder={"選択肢" + (num +1)} style={{marginBottom: "5px"}} helperText={CountWord(content.content) > 30 && <span style={{color: "var(--red)"}}>全角30文字以内で正しく入力してください</span>}
                                                />
                                            ))

                                       }
                                        {survey.questionList[index].choiceList.length < 5 &&
                                            <IconButton className={styles.addIcon} onClick={() => AddChoice(index)}>
                                                <AddIcon style={{color:"var(--red)"}}/>
                                            </IconButton>
                                       }
                                    </li>
                                    <li>
                                        <PuiTypography>アンケート表示時間制限</PuiTypography>
                                        <RadioGroup aria-label="answerLimitTime" defaultValue={displayMillisCustomFlagList[index] === false ? String(row.displayMillis) : "1"}
                                            onChange={(event) => SelectAnswerLimit(index, Number(event.target.value))} style={{flexDirection: "row"}}
                                        >
                                            <FormControlLabel value="15000" control={<RedRadio/>} label="15秒"/>
                                            <FormControlLabel value="30000" control={<RedRadio/>} label="30秒"/>
                                            <FormControlLabel value="60000" control={<RedRadio/>} label="60秒"/>
                                            <FormControlLabel value="0" control={<RedRadio/>} label="無制限"/>
                                            <FormControlLabel value="1" control={<RedRadio/>} label="カスタム"/>
                                            {displayMillisCustomFlagList[index] === true &&
                                                <div style={{margin: "auto 0", position: "relative"}}>
                                                    <sup style={{color:"var(--red)"}}>*</sup>
                                                    <TextField style={{width: "65px"}} defaultValue={row.displayMillis/ 1000} autoFocus required rows={1} rowsMax={600} type="number"
                                                        InputProps={{
                                                            endAdornment: <InputAdornment position="end">秒</InputAdornment>
                                                       }}
                                                        onChange={(event) => InputDisplayLimit(index, Number(event.target.value)* 1000)}
                                                        helperText={isErrorInputLimit[index] && <span style={{color: "var(--red)"}}>1〜600</span>}
                                                    />
                                                </div>
                                           }
                                        </RadioGroup>
                                    </li>
                                </ul>

                            ))}
                            {survey.questionList.length < 5 &&
                                <IconButton onClick={AddQuestion} className={styles.addQuestionIcon} >
                                    <AddCircleOutlineOutlinedIcon style={{color:"var(--red)"}}/>
                                </IconButton>
                           }
                        </div>
                        <div className={styles.bottomButton}>
                            <div className={styles.cancelButton}>
                                <PuiButton variant="outlined" onClick={ClickCancelButton}>キャンセル</PuiButton>
                            </div>
                            <div className={styles.doneButton}>
                                <PuiButton variant="outlined" onClick={ClickDoneButton}>編集完了</PuiButton>
                            </div>
                        </div>
                        <div>
                            <PuiMessage
                                open={isVisibleErrorMessage}
                                type="error"
                                title={errorMessage}
                                duration={5000}
                                onClose={CloseErrorMessage}
                            />
                        </div>
                    </div>
                </Modal>
           }
        </>
    );
}

export default EditSurveyDetail;
